import { BRAND_LIST, CountryLanguageSwitcher, DistanceUnit } from 'typings'
import * as Typings from '../typings'

const RomaniaLocale: Typings.LocaleType = {
  IS_EU: true,
  REGION: Typings.RegionGroupNames.OTHER,
  CODE: 'RO',
  LANGUAGE_CODE: 'en',

  LONG_NAME: 'Romania',
  SHORT_NAME: 'RO',

  DISPLAY_NAME: 'Romania (English)',
  DISPLAY_COUNTRY: 'Romania (English)',

  GEO_COORDINATES: {
    INITIAL_LATITUDE: 45.9418997,
    INITIAL_LONGITUDE: 25.0200795,
    INITIAL_ZOOM: 5,
    INITIAL_ZOOM_DETAILS_PAGE: 15,
  },

  AREAS: {
    '1': 'Alba',
    '2': 'Arad',
    '3': 'Argeș',
    '4': 'Bacău',
    '5': 'Bihor',
    '6': 'Bistrița-Năsăud',
    '7': 'Botoșani',
    '8': 'Brăila',
    '9': 'Brașov',
    '10': 'Bucharest',
    '11': 'Buzău',
    '12': 'Călărași',
    '13': 'Caraș-Severin',
    '14': 'Cluj',
    '15': 'Constanța',
    '16': 'Covasna',
    '24': 'Dâmbovița',
    '25': 'Dolj',
    '26': 'Galați',
    '27': 'Giurgiu',
    '28': 'Gorj',
    '29': 'Harghita',
    '30': 'Hunedoara',
    '31': 'Ialomița',
    '32': 'Iași',
    '33': 'Ilfov',
    '34': 'Maramureș',
    '35': 'Mehedinți',
    '36': 'Mureș',
    '37': 'Neamț',
    '38': 'Olt',
    '39': 'Prahova',
    '40': 'Sălaj',
    '41': 'Satu Mare',
    '42': 'Sibiu',
    '43': 'Suceava',
    '44': 'Teleorman',
    '45': 'Timiș',
    '46': 'Tulcea',
    '47': 'Vâlcea',
    '48': 'Vaslui',
    '49': 'Vrancea',
  },

  HOME_PAGE_URL: 'https://www.uniqlo.com/eu-ro/en/',

  MAP_MOBILE_URL: 'https://map.uniqlo.com/eu-ro/en/',

  CONTACT_US_URL: 'https://faq-eu.uniqlo.com/',
  TERMS_OF_USE_URL:
    'https://faq-eu.uniqlo.com/pkb_Home_UQ_EU?l=en&c=category_uq_eu_dk_se%3ARenew_UQEU_C7_3',
  PRIVACY_POLICY_URL:
    'https://faq-eu.uniqlo.com/pkb_Home_UQ_EU?l=dk&c=category_uq_eu_dk_se%3ARenew_UQEU_C7_2',

  POSTCODE_FORMAT: /^[0-9]{6}$/,

  CLIENT_ID: {
    [BRAND_LIST.UQ]: '',
  },

  DISTANCE_UNIT: DistanceUnit.KM,

  SHOW_COUNTRY_LANGUAGE_MODAL: {
    [BRAND_LIST.UQ]: CountryLanguageSwitcher.HEADER_SWITCHER_MODAL,
    [BRAND_LIST.GU]: CountryLanguageSwitcher.ALL_DISABLED,
    [BRAND_LIST.PL]: CountryLanguageSwitcher.ALL_DISABLED,
  },

  ONE_TRUST_FOOTER: {
    [BRAND_LIST.UQ]: true,
  },
}

export default RomaniaLocale
